/* eslint-disable react/jsx-props-no-spreading */
import type * as React from 'react';
import type { JobSearchResultResponse } from '@doda/api-client/aspida/@types';
import { DodaPrime } from '@doda/common/src/components/DodaPrime';
import styles from './index.module.scss';

/**
 * カードタイプを表す型
 */
type CardType = 'BC' | 'DE';

/**
 * Mediaコンポーネントのプロパティ型
 */
interface MediaProps {
  /** カードタイプ ('BC' or 'DE') */
  cardType: CardType;
  /** 画像のパス */
  imagePath: JobSearchResultResponse['imagePath'];
  /** 画像のリンク先URL */
  imgHref: string;
  /** DE原稿の場合のみ 動画のID */
  movieId?: JobSearchResultResponse['movieId'];
  /** DE原稿の場合のみ求人ID */
  jid?: JobSearchResultResponse['jid'];
  /** 企業名 */
  corporateName: JobSearchResultResponse['corporateName'];
  /** 職種名 */
  occupationName: JobSearchResultResponse['occupationName'];
  /** 画像の読み込み優先度 */
  imagePriority?: boolean;
  /** ナビゲートのためのクリックハンドラー */
  onNavigate?: React.MouseEventHandler<HTMLAnchorElement>;
}

/**
 * カードタイプごとのメディアサイズ
 */
const mediaSize: Record<
  CardType,
  Pick<React.ComponentProps<'img'> & React.CSSProperties, 'width' | 'height'>
> = {
  BC: {
    width: 260,
    height: 195,
  },
  DE: {
    width: 395,
    height: 283,
  },
};

/**
 * 画像・動画用コンポーネント
 * @param {MediaProps} props - コンポーネントのプロパティ
 * @returns {JSX.Element} MediaのJSX要素
 */
export const Media = (props: MediaProps) => {
  const {
    cardType,
    imagePath,
    imgHref,
    corporateName = '',
    occupationName = '',
    movieId,
    jid,
    imagePriority,
    onNavigate,
  } = props;

  if (movieId && jid)
    return (
      <div style={mediaSize.DE}>
        <DodaPrime movieId={movieId} jobId={jid} />
      </div>
    );

  const imgSrc = imagePath || '/DodaFront/Html/img_cmn/transparent.gif';

  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a
      href={imgHref}
      target="_blank"
      rel="noopener"
      className={styles['jobCard-media__imgWrap']}
      onClick={onNavigate}
    >
      <img
        loading={imagePriority ? 'eager' : 'lazy'}
        src={imgSrc}
        width={cardType === 'BC' ? mediaSize[cardType].width : undefined}
        height={mediaSize[cardType].height}
        alt={`${corporateName} ${occupationName}`}
        className={styles['jobCard-media__img']}
      />
    </a>
  );
};
